module.exports = __webpack_public_path__ + "img/武怀良.4977f3a3.png";